import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EDX } from "@/lib/api";

export default function Preloader() {
  const [done, setDone] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (sessionStorage.getItem("edx_loaded")) {
      setDone(true);
      return;
    }
    let p = 0;
    const t = setInterval(() => {
      p += Math.random() * 18 + 4;
      if (p >= 100) {
        p = 100;
        clearInterval(t);
        setTimeout(() => {
          setDone(true);
          sessionStorage.setItem("edx_loaded", "1");
        }, 350);
      }
      setProgress(Math.min(100, Math.round(p)));
    }, 110);
    return () => clearInterval(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6 } }}
          className="fixed inset-0 z-[100] bg-edx-space flex items-center justify-center"
        >
          <div className="absolute inset-0 edx-aurora-bg opacity-50" />
          <div className="absolute inset-0 edx-grid opacity-30" />

          <div className="relative z-10 flex flex-col items-center gap-6">
            <motion.div
              animate={{ rotateY: [0, 360] }}
              transition={{ duration: 2.5, repeat: Infinity, ease: "linear" }}
              style={{ transformStyle: "preserve-3d" }}
            >
              <img src={EDX.logo} alt="EDENOX" className="h-24 w-24 rounded-2xl" />
            </motion.div>
            <div className="text-center">
              <div className="font-display font-bold text-2xl text-white">EDENOX</div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-edx-cyan mt-1 font-mono">
                Innovation, Fortified!
              </div>
            </div>
            <div className="w-64 h-1 bg-white/5 rounded-full overflow-hidden">
              <motion.div
                className="h-full bg-gradient-to-r from-edx-cyan via-edx-purple to-edx-pink"
                animate={{ width: `${progress}%` }}
                transition={{ ease: "linear", duration: 0.1 }}
              />
            </div>
            <div className="font-mono text-[10px] text-edx-muted uppercase tracking-widest">
              Booting system · {progress}%
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
